import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { initSentry } from "./Services/sentry";
import { store } from "./Store/store";
import { initClientMonitoring, trackWebVitalMetric } from "./Services/monitoring";

initSentry();

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found while mounting the application");
}

const root = ReactDOM.createRoot(container);

void initClientMonitoring();

root.render(
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}></PersistGate> */}
    <App />
  </Provider>
);

reportWebVitals((metric) => {
  trackWebVitalMetric({
    id: metric.id,
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
  });
});
